module.exports = __webpack_public_path__ + "img/globe-2.6be20687.svg";